import { useEffect, useState } from "react";
import DataTable from "../../common/data-table/data-table";
import downloadableFormsMap from "./downloadable-forms-map";
import { ReactComponent as DownloadButtonIcon } from "../../../../assets/icons/download-btn.svg";
import downloadForm from "./download-form";

const DownloadableForms = () => {
    const [tableHeader, setTableHeader] = useState([
        { name: "Form Name", key: "formName" },
        { name: <div className="text-center">Download Form</div>, key: "downloadButton" },
    ]);

    const [tableData, setTableData] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        let data = [];
        downloadableFormsMap.forEach((form) => {
            data.push({
                formName: form.name,
                downloadButton: (
                    <div className="d-flex justify-content-center">
                        <div
                            className="cursor-pointer"
                            onClick={() => {
                                downloadForm(form.path, form.type, form.name,setIsLoading);
                            }}
                        >
                            <DownloadButtonIcon width="24" height={24} />
                        </div>
                    </div>
                ),
            });
        });

        setTableData(data);
    }, []);

    return (
        <div id="tasks">
            <div className="container-fluid p-0">
                <div className="d-flex align-items-center flex-row card p-4 no-radius border-0 border-bottom">
                    <div className="m-0 h5">Downloadable Forms</div>
                    <div className="flex-fill"></div>
                    <div className="d-flex align-items-center">
                        <div className="ms-3">
                            <input
                                value={searchText}
                                onChange={(e) => setSearchText(e.target.value)}
                                type="text"
                                placeholder="Search for Forms"
                                className="form-control"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className="container-fluid p-3">
                <div className="card p-3 border-0">
                    <b className="mb-4">Download forms to fill them offline</b>
                    <div className="position-relative">
                        <DataTable 
                            search={searchText} 
                            header={tableHeader} 
                            rawData={tableData} 
                        />
                        {isLoading && (
                            <div
                                className="position-absolute top-0 start-0 w-100 h-100"
                                style={{ background: "#0002" }}
                            >
                                <div className="d-flex w-100 h-100 align-items-center justify-content-center">
                                    <div className="card flex-row d-flex align-items-center justify-content-center p-5">
                                        <div className="me-3">Downloading...</div>
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DownloadableForms;
